const S3_HOSTNAME = 'https://s3-us-west-2.amazonaws.com'

const parseBucket = (seg) =>
    `bss-${seg}-${process.env.REACT_APP_STAGE}-${process.env.REACT_APP_AWS_ACCOUNT_ID}`

export const DOCUMENTS = parseBucket('documents')
export const VIDEO_LIBRARY = parseBucket('video-library')
export const VIDEO_THUMBNAILS = parseBucket('video-thumbnails')
export const VIDEO_TRACKS = parseBucket('video-tracks')
export const PLAYLIST_IMAGES = parseBucket('playlist-images')
export const TRANSCRIPTIONS = parseBucket('video-transcriptions')

export const DOCUMENTS_URL = `${S3_HOSTNAME}/${DOCUMENTS}/`
export const VIDEO_LIBRARY_URL =
    process.env.REACT_APP_STAGE === 'prod' ? 'https://cdn.bssnet.com' : 'https://cdn-dev.bssnet.com'
export const VIDEO_THUMBNAILS_URL = `${S3_HOSTNAME}/${VIDEO_THUMBNAILS}/`
export const VIDEO_TRACKS_URL = `${S3_HOSTNAME}/${VIDEO_TRACKS}/`
export const PLAYLIST_IMAGES_URL =
    process.env.REACT_APP_STAGE === 'prod'
        ? 'https://d15pxx5jd0nfuj.cloudfront.net/'
        : 'https://dtknzz1tmzqvl.cloudfront.net/'
export const TRANSCRIPTIONS_URL = `${S3_HOSTNAME}/${TRANSCRIPTIONS}/`
